import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { UnosStatusComponent } from '../unos-status/unos-status.component';

@Component({
	selector: 'app-home-stip',
	templateUrl: './home-stip.component.html',
	styleUrls: ['./home-stip.component.css']
})
export class HomeStipComponent implements OnInit {
	loading : boolean = false; 
	currentView = 'main';
	kategorije : any = [];
	tipoviPrijave : any = [];
	kategorijePrijave : any = [];
	idTipaPrijave : any = null;
	idKategorijePrijave : any = null;
	prijave : any = [];
	odabrane_prijave : any = [];
	novaPrijavaStip : boolean = true; 
	odabranaStipId : any = null;
	prekoPortala = false;
	//old
	nazivKategorije : any = null; 
	filterIme : any = '';
	filterPrezime : any = '';
	filterDatum : any = '';

	prijavadomponisti : any = null;
	prijavadomobradi : any = null;
	sortOption = 1; //dozvoljene vrijednosti su bodovi i vrijeme
	modalInstance : any = null;
	jedinice : any = [];
	statusi : any = [];
	server_data : any = "";
	tekstMaila : any = '';

	constructor(public globalSrvc: GlobalService, public http : HttpClient, private route: ActivatedRoute, public router: Router) { }

	ngOnInit() {
		setTimeout(() => {
			/*var elems = document.querySelectorAll('.modal');
    		var instances = M.Modal.init(elems, {});*/
		}, 1000);

		this.ucitajtipove();	
	}

	ucitajtipove(){
		this.loading = true; 
		setTimeout(() => {
			this.http.get(this.globalSrvc.rootUrl + 'prijave/stip/tipovi', {params: {}})
			.subscribe(data => {
				//console.log('data', data);
				this.server_data = data;
				this.tipoviPrijave = this.server_data.tipovi;
				//this.kategorijePrijave = this.server_data.kategorije;
				this.kategorijePrijave = null;
				this.loading = false;

				setTimeout(() => {
					let elems = document.querySelectorAll('.tooltipped');
            		let instances = M.Tooltip.init(elems, {});    
				}, 1000);

				/*if (this.kategorije.length > 0){					
					this.idTipaPrijave = this.kategorije[0].id;
					this.ucitajKandidate();
				}*/
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}

	logout(){
		this.globalSrvc.logout();
		this.globalSrvc.redirectToLogin();
	}

	rList : any = null;

	tipSelected(event){
		this.idKategorijePrijave = '';
		this.ucitajKandidate();
	}

	kategorijaSelected(event){
		//this.idKategorijePrijave = '';
		//this.ucitajKandidate();
	}

	jeSrednja(){
		if (this.idTipaPrijave == '1' || this.idTipaPrijave == '2')
			return true; 
		else 
			return false; 
	}

	onInsertStip(data){
		this.currentView = 'main';
		var elem = document.getElementById('modal10');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {this.ucitajKandidate();}});
		instance.open();
	}

	ucitajKandidate(){
		this.loading = true; 
		this.sortOption = 1;

		this.http.get(this.globalSrvc.rootUrl + 'prijave/stip/admin/ranglista', {params: {idTipaPrijave : this.idTipaPrijave, idKategorijePrijave : this.idKategorijePrijave}})
		.subscribe(data => {
			if (data){
				this.rList = data;
				this.prijave = this.rList.kandidati;
				this.kategorijePrijave = this.rList.kategorije;
				//console.log(this.prijave);
				this.initTooltips();
			}
			this.loading = false;
		},
		error => {
			this.loading = false;
		});
	}

	getBodoviLuca(luca){
		if (!luca)
		 	return '';
		
		if (luca == 1)
		 	return 10;
		if (luca == 2)
			return 5;

		return '';
	}

	getBodoviPorStatus(value){
		if (value == '1') return '5';
		else return '';
	}

	getOcjenaExterna(extocjena){
		if (!extocjena)
		 	return '';
		
		return extocjena;
	}

	getBodoviTakmicenja(bodovi){
		if (!bodovi)
			return '';

		if (bodovi == '2')
			return 'I';

		if (bodovi == '1')
			return 'II';
		
		return '';
		
	}

	getStepenStudija(stepen){
		if (!stepen)
			return '';

		if (stepen == 'O')
			return 'Osnovne';

		if (stepen == 'M')
			return 'Master';
		
		return '';
		
	}

	dodajPrijavuStip(){
		if (!this.idTipaPrijave){
			M.toast({html:'Odaberite tip prijave', displayLength : 4000});
			return; 
		}
		let item = this.kategorije.find((x) => x.id == this.idTipaPrijave);		
		if (item) this.nazivKategorije = item.naziv;

		this.novaPrijavaStip = true;
		this.odabranaStipId = null;
		this.prekoPortala = false;
		this.currentView = 'stip';
		//this.router.navigate(["prijavaPage"]);
	}

	brmjesta(){
		this.currentView = 'brmjesta';
	}

	nijeAbonent(){
		if (this.idTipaPrijave == '5' || this.idTipaPrijave == '6')
			return false; 
		else 
			return true;
	}

	getNazivStudPrograma(){
		let item = this.kategorije.find((item) => item.id == this.idTipaPrijave);

		if (!item)
			return '';

		return item.naziv;
	}

	onInsertDom(data){
		this.currentView = 'main';
		var elem = document.getElementById('modal10');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {this.ucitajKandidate();}});
		instance.open();
	}

	pregled(prijava){
		this.novaPrijavaStip = false;
		this.odabranaStipId = prijava.id;
		this.currentView = 'stip';
		this.prekoPortala = prijava.prekoPortala; 
	}

	ponistiprijavu(prijava){
		this.prijavadomponisti = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal7');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}

	obradiprijavu(prijava){
		this.prijavadomobradi = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal9');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}

	ucitajStatuse() {	
		if (!this.idTipaPrijave){
			M.toast({html:'Odaberite tip prijave', displayLength : 4000});
			return; 
		}

		if (!this.idKategorijePrijave){
			M.toast({html:'Odaberite kategoriju', displayLength : 4000});
			return; 
		}

		if (this.filterIme || this.filterPrezime || this.filterPrezime){
			M.toast({html:'Poništite filtere prije postavljanja statusa', displayLength : 4000});
			return; 
		}
		this.odabrane_prijave = this.prijave.filter((item) => item.idKategorije == this.idKategorijePrijave);
		
		this.loading = true;
		this.http.get('prijavestip/statusi/liste', { params: { idTipa : this.idTipaPrijave } })
			.subscribe(data => {
				//console.log(data);
				this.loading = false;
				this.server_data = data;	
				this.statusi = this.server_data.statusi;
				this.openUnosStatusModal();
			}
			, error => {
				this.loading = false;
			});	
	}

	onInsertSendMail(data){
		this.currentView = 'main';
		var elem = document.getElementById('modalmailStipText');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}

	posaljimail(){
		let url = 'prijave/stip/sendmail';
		//console.log(url);
		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, {text : this.tekstMaila?this.tekstMaila:'', 'id' : this.idTipaPrijave})
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						//this.ucitajKandidate();
						M.toast({html:'Mailovi su uspješno poslati', displayLength : 4000});
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	openUnosStatusModal(){
		var elem = document.getElementById('modalStatusStip');					
		this.modalInstance = M.Modal.init(elem, {onCloseEnd : () => {console.log('destroy'); this.modalInstance.destroy();}});
		this.modalInstance.open();
		//this.modalRef.ucitaj();
	}

	onInsertStatus(event){
		this.ucitajKandidate();
		if (this.modalInstance)
			this.modalInstance.destroy();
	
		this.initTooltips();
	}

	onCancel(data){
		this.currentView = 'main';
		this.initTooltips();
	}

	initTooltips(){
		setTimeout(() => {
			let elems = document.querySelectorAll('.tooltipped');
            let instances = M.Tooltip.init(elems, {});    
		}, 500);
	}

	msg : any = null;

	ponistiPrijavuDomPotvrda(){
		let url = 'prijave/admin/dom/ponisti';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, this.prijavadomponisti)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						this.ucitajKandidate();
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	obradiPrijavuDomPotvrda(){
		let url = 'prijave/admin/dom/obradi';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, this.prijavadomobradi)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						this.ucitajKandidate();
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	posaljistatuse(){
		let url = 'prijave/statusi/sendmail';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, this.rList)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						//this.ucitajKandidate();
						M.toast({html:'Mailovi su uspješno poslati', displayLength : 4000});
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	promijeniSort(){
		if (this.sortOption == 1){
			//sortirano po bodovima, sortiraj po vremenu
			this.prijave.sort( (a, b) => a.datumPrijave<b.datumPrijave?1:-1);
			
			this.sortOption = 2;
			//console.log(this.prijave);
		}
		else {
			this.prijave.sort( (a, b) => parseFloat(a.ukupnoBodova)>parseFloat(b.ukupnoBodova)?-1:1);
			this.sortOption = 1;
		}
	}

	getNazivDugmetaSort(){
		return this.sortOption==1?'Sortiraj po vremenu':'Sortiraj po bodovima';
	}

	ranglistaPDF(outType){
        if (!this.idTipaPrijave){
			M.toast({html:'Odaberite tip prijave', displayLength : 4000});
			return; 
		}

		if (!this.idKategorijePrijave){
			M.toast({html:'Odaberite kategoriju', displayLength : 4000});
			return; 
		}
		let kategorija = this.kategorijePrijave.find(item => item.id == this.idKategorijePrijave);
        
		if (!kategorija){
			M.toast({html:'Odaberite kategoriju', displayLength : 4000});
			return; 
		}

        this.loading = true;
        let url = 'getReport/stip/ranglista';
        
        this.http.get(url, {params : {'idTipa' : this.idTipaPrijave, 'idKategorije' : this.idKategorijePrijave, 'nazivKategorije' : kategorija.naziv, 'outType' : outType}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, outType);
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }

	studentiXLS(){
        this.loading = true;
        let url = 'getReport/stip/studenti/alldata';
        
        this.http.get(url, {params : {}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'XLS');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja liste');
        });    
    }

	djaciXLS(){
        this.loading = true;
        let url = 'getReport/stip/djaci/alldata';
        
        this.http.get(url, {params : {'idTipa' : this.idTipaPrijave}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'XLS');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja liste');
        });    
    }
	
	ugovor(prijava){
        //console.log(this.ucenik);
        this.loading = true;
        let url = '';
        
		if (this.idTipaPrijave == '1' || this.idTipaPrijave == '2'){
			url = 'prijave/djaci/ugovor';
		}

        this.http.get(url, {params : {'idPrijave' : prijava.id}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'word');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }


	polazuextest(outType){
        //console.log(this.ucenik);
        this.loading = true;
        let url = 'getReport/polazuexttest';
        let studProgram = this.kategorije.find(item => item.id == this.idTipaPrijave);
        
		if (!studProgram)
			return;
        
        this.http.get(url, {params : {'outType' : outType}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, outType);
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }

	openhelp(){
		
        let url = 'upustvo';
        this.http.get(url, {params : {}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'pdf');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom fajla');
        });   
	}
}
